/**
 * Shared coach filtering for candidate coach lists (modal + video-frame picker).
 */

export function filterCoachesByCompany(
  coaches,
  userCompanyId,
  partnerCandidate,
) {
  if (!coaches) return []

  if (!partnerCandidate) {
    return coaches.filter((coach) => !coach.companyId)
  }

  if (!userCompanyId) return []

  return coaches.filter(
    (coach) => coach.companyId && coach.companyId === userCompanyId,
  )
}

export function filterCoachesByLocale(coaches, userLocale) {
  if (!userLocale || !coaches) return coaches || []
  return coaches.filter(
    (coach) => coach.coachLocales && coach.coachLocales.includes(userLocale),
  )
}

export function filterCoachesByStatus(coaches, status) {
  if (!coaches) return []
  return coaches.filter((coach) => coach.status === status)
}

/**
 * Apply locale/company filters (optional) then split into available vs busy.
 * Load balancing is applied by the caller via applyCoachLoadBalancing on available.
 */
export function getLocaleCompanyFilteredCoaches(
  coaches,
  { userLocale, userCompanyId, partnerCandidate } = {},
) {
  if (!coaches) return []
  const companyFiltered = filterCoachesByCompany(
    coaches,
    userCompanyId,
    partnerCandidate,
  )
  return filterCoachesByLocale(companyFiltered, userLocale)
}
